import { useAuth } from '@vizit/auth';
import { useIdentifyFeatureFlagUser } from '@vizit/feature-flags';

/**
 * Keeps LaunchDarkly's user in step with the auth state, so login, SSO and logout change the flags
 * without a reload. Renders nothing; it sits inside `AuthProvider`, which the flag provider wraps.
 */
export function FeatureFlagIdentity() {
  const { userId, userEmail, organizationId, defaultPortfolioId } = useAuth();

  // Same user the provider builds from localStorage at page load (see feature-flags-init).
  useIdentifyFeatureFlagUser({
    key: userId || 'anonymous',
    email: userEmail || undefined,
    organizationId: organizationId || undefined,
    workspaceId: defaultPortfolioId || undefined,
  });

  return null;
}
